import {isBondo, isNotBuzzCast, isRealLive} from "../util";

export default {
  data() {
    return {
      isInBondo: isBondo(),
      isInRealLive: isRealLive(),
      isInBuzzCast: !isNotBuzzCast()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/multiDomain.js